import { Button, Space } from "antd";
import AuthSubjectInfo from "../../AuthSubject/authInfo";
import InfoCard from "../shared/infoCard";
import Tip from "../shared/tip";
/**
 *
 * @param {{
 * noTitle: boolean,
 * width: number|string,
 * subject: Object,
 * onOk ()=>void,,
 * onBack: ()=>void,
 * footerStyle: import("react").CSSProperties
 * } & import("react").HTMLAttributes} props
 * @returns
 */
export default function SubjectConfirm({
  noTitle,
  width = 604,
  subject,
  onOk,
  onBack,
  footerStyle = {},
  ...rest
}) {
  const isCompany = subject.type === "company";
  return (
    <div style={{ width, margin: "auto" }} {...rest}>
      {!noTitle && (
        <h2 style={{ margin: "38px 0", textAlign: "center" }}>授权信息确认</h2>
      )}
      <AuthSubjectInfo />
      <Tip
        message={"请再次确认填写信息，提交后将无法修改"}
        style={{ margin: "16px 0" }}
      />
      <InfoCard>
        <InfoCard.Item
          label={isCompany ? "公司名称" : "姓名"}
          value={subject.name}
          justify
        />
        <InfoCard.Item
          label={isCompany ? "单位代码" : "身份证件"}
          value={subject.id_no}
        />
        <InfoCard.Item label="联系电话" value={subject.phone} />
        {subject.email && (
          <InfoCard.Item label="邮箱地址" value={subject.email} />
        )}
        {subject.address && (
          <InfoCard.Item label="联系地址" value={subject.address} />
        )}
      </InfoCard>
      <Space
        style={{
          justifyContent: "center",
          width: "100%",
          margin: "32px 0",
          ...footerStyle,
        }}
      >
        <Button onClick={onBack}>返回修改</Button>
        <Button type="primary" onClick={onOk}>
          确认提交
        </Button>
      </Space>
    </div>
  );
}
